var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyTickSquareBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1621_15600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7494 4.47701C22.9446 4.67228 22.9446 4.98886 22.7494 5.18412L12.2715 15.662C12.0763 15.8572 11.7597 15.8573 11.5645 15.662L7.10353 11.2024C6.90824 11.0072 6.90819 10.6906 7.10343 10.4953C7.29866 10.3 7.61524 10.3 7.81053 10.4952L11.9179 14.6014L22.0423 4.47701C22.2375 4.28175 22.5541 4.28175 22.7494 4.47701Z",
    fill: "#51546B",
    stroke: "#51546B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72909 4.146C5.30916 4.146 4.90643 4.31281 4.6095 4.60974C4.31257 4.90668 4.14575 5.3094 4.14575 5.72933V19.271C4.14575 19.6909 4.31257 20.0937 4.6095 20.3906C4.90643 20.6875 5.30916 20.8543 5.72909 20.8543H19.2708C19.6907 20.8543 20.0934 20.6875 20.3903 20.3906C20.6873 20.0937 20.8541 19.6909 20.8541 19.271V10.0705C20.8541 9.79433 21.0779 9.57048 21.3541 9.57048C21.6302 9.57048 21.8541 9.79433 21.8541 10.0705V19.271C21.8541 19.9561 21.5819 20.6132 21.0974 21.0977C20.613 21.5822 19.9559 21.8543 19.2708 21.8543H5.72909C5.04394 21.8543 4.38686 21.5822 3.90239 21.0977C3.41792 20.6132 3.14575 19.9561 3.14575 19.271V5.72933C3.14575 5.04419 3.41792 4.38711 3.90239 3.90264C4.38686 3.41817 5.04394 3.146 5.72909 3.146H19.2057C19.4818 3.146 19.7056 3.36985 19.7056 3.646C19.7056 3.92214 19.4818 4.146 19.2057 4.146H5.72909Z",
    fill: "#51546B",
    stroke: "#51546B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1621_15600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyTickSquareBorder);
export default __webpack_public_path__ + "static/media/GreyTickSquareBorder.4da3cc380e65fd05fd75e69b29579326.svg";
export { ForwardRef as ReactComponent };